exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dropdown .dropdown-menu .dropdown-header {\n  font-size: 14px;\n  font-weight: 200; }\n  .dropdown .dropdown-menu .dropdown-header.about {\n    font-size: 14px;\n    margin-left: 12px; }\n\n.dropdown .dropdown-menu .tooltip {\n  display: block; }\n\n.about {\n  width: 200px; }\n  .about .spinner-pad {\n    margin-left: 2px; }\n\nabout .dropdown .dropdown-toggle clr-icon[shape=\"caret\"] {\n  margin: 0px 12px; }\n\n/* Common Dialog CSS */\n.modal-dialog .form-block {\n  margin-bottom: 0px; }\n\n.modal-dialog .modal-footer vca-spinner {\n  margin-top: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/about/about.scss
// module id = khYa
// module chunks = 0